module.exports = __webpack_public_path__ + "img/biaoti_1.ee7b802d.png";